import { createActions } from "redux-actions";

const action = createActions({
  ADMIN: {
    CLEAN_BUSINESS_ACTIVITIES: undefined,
    API: {
      CLEAN_BUSINESS_ACTIVITIES: undefined
    }
  }
})

const configuration = {
  name: 'cleanBusinessActivities',
  action: action,
  sagas: undefined,
  reducers: {
    reducer: (state, action) => ({
      ...state,
      businessActivities: undefined,
    })
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/admin/configurations/cleanBusinessActivities.js